import { render } from "./ArtworksView.vue?vue&type=template&id=9236fb0e&scoped=true"
import script from "./ArtworksView.vue?vue&type=script&lang=js"
export * from "./ArtworksView.vue?vue&type=script&lang=js"

import "./ArtworksView.vue?vue&type=style&index=0&id=9236fb0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9236fb0e"]])

export default __exports__